import { PatchQueueRequestPriority } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemotePatchPriorityAskRequest
  extends BaseHttpService<PatchQueueRequestPriority.Model>
  implements PatchQueueRequestPriority
{
  async patch({
    priority,
    status,
    comment,
    assignee,
    dueDate,
    parentId,
    title,
  }: PatchQueueRequestPriority.Params): Promise<PatchQueueRequestPriority.Model> {
    const body = { priority, status, comment, assignee, dueDate, parentId, title };
    return await this.request('patch', body);
  }
}
